import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SessionContextService } from '../../context/session-context.service';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent {

  public sidebarOpen = false;
  public dropdown = '';

  constructor(private readonly _router: Router,
    private readonly _sessionContext: SessionContextService) {
  }

  public changeDropdown(optionMenu: string) {
    this.dropdown = this.dropdown === optionMenu ? '' : optionMenu;
  }

  public get url() {
    return this._router.url;
  }

  public get claims() {
    return this._sessionContext.sessionUser.lsClaimTypes ? this._sessionContext.sessionUser.lsClaimTypes : [];
  }

  public get role() {
    return this._sessionContext.sessionUser.role;
  }

}
